"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_79687299{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.rootVertical_79687299{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.item_79687299{-ms-flex-negative:0;flex-shrink:0;display:inherit}\n" }]);
exports.root = "root_79687299";
exports.rootVertical = "rootVertical_79687299";
exports.item = "item_79687299";
//# sourceMappingURL=OverflowSet.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/OverflowSet/OverflowSet.scss.js
// module id = 1030
// module chunks = 0